import React, { useState } from "react";
import Datenblatt from "./Datenblatt";

import { MsalProvider, AuthenticatedTemplate, useMsal, UnauthenticatedTemplate } from "@azure/msal-react";
import { loginRequest } from "./msal/authConfig";
import { Button } from "react-bootstrap";
import { useConfig } from "./ConfigContext";

export default function AuthContent({
   handleRedirect,
   handleLogoutRedirect,
   activeAccount,
   getMsSharepointData,
   postMsSharelink,
   postMsSharepointNewFolder,
   updateMsSharepointNewFolder,
}) {
   const config = useConfig();
   return (
      <div className="App">
         {config?.ms365?.active ? (
            <>
               <AuthenticatedTemplate>
                  {activeAccount ? (
                     <>
                        <Datenblatt
                           activeAccount={activeAccount}
                           getMsSharepointData={getMsSharepointData}
                           postMsSharelink={postMsSharelink}
                           postMsSharepointNewFolder={postMsSharepointNewFolder}
                           updateMsSharepointNewFolder={updateMsSharepointNewFolder}
                        />
                        <Button
                           variant="outline-secondary"
                           style={{ position: "absolute", top: "10px", left: "10px" }}
                           onClick={handleLogoutRedirect}
                        >
                           &#xf08b;
                        </Button>
                     </>
                  ) : null}
               </AuthenticatedTemplate>
               <UnauthenticatedTemplate>
                  <div className="m-5">
                     <Button className="p-5 w-100" onClick={handleRedirect} variant="primary">
                        Login mit Teamsaccount (Microsoft)
                     </Button>
                  </div>
               </UnauthenticatedTemplate>
            </>
         ) : (
            <>
               <Datenblatt
                  activeAccount={activeAccount}
                  getMsSharepointData={getMsSharepointData}
                  postMsSharelink={postMsSharelink}
                  postMsSharepointNewFolder={postMsSharepointNewFolder}
                  updateMsSharepointNewFolder={updateMsSharepointNewFolder}
               />
            </>
         )}
      </div>
   );
}
